module.exports = __webpack_public_path__ + "static/media/Resold.c9e54655.png";